import { Injectable } from '@angular/core';
import { CbreAlertService } from '@cbre/alerts';
import { PropertySetPermission } from '@miq/domain/property-sets';
import { PropertySetsHttpService } from '../../services/http/property-sets-http.service';
import { L10nTranslationService } from 'angular-l10n';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionTableHelperService {
  permissions$: Observable<{ group: PropertySetPermission[]; user: PropertySetPermission[] }>;

  constructor(
    private propertySetsHttpService: PropertySetsHttpService,
    private translationService: L10nTranslationService,
    private cbreAlertService: CbreAlertService
  ) {}

  loadPermissions(psId: number): Observable<{ group: PropertySetPermission[]; user: PropertySetPermission[] }> {
    return this.propertySetsHttpService.getPermissions(psId).pipe(
      map(permissions => ({
        group: permissions.filter(p => p.type === 'Group'),
        user: permissions.filter(p => p.type === 'User'),
      }))
    );
  }

  deletePermission(selectedPermission: Record<string, any>[], propertySetId: number) {
    if (!selectedPermission) {
      return;
    }
    const permissionIds = selectedPermission.map(permission => permission.id);
    const deletePermission = permissionIds.map(permissionId =>
      this.propertySetsHttpService.deletePropertySetPermission(permissionId)
    );

    forkJoin(deletePermission).subscribe({
      next: () => {
        this.permissions$ = this.loadPermissions(propertySetId);
      },
    });
  }

  savePermission(payload: PropertySetPermission[], propertySetId: number) {
    const savePermission = this.propertySetsHttpService.savePropertySetPermission(payload, propertySetId);
    if (savePermission) {
      savePermission.subscribe({
        next: () => {
          this.permissions$ = this.loadPermissions(propertySetId);
        },
        error: err => {
          if (err.status === 400) {
            this.cbreAlertService.showErrorSnackBar(
              this.translationService.translate('propertySet.recordExists').replace('{{type}}', payload[0].type)
            );
          }
        },
      });
    }
  }

  updatePermission(payload: PropertySetPermission[], propertySetId: number) {
    const updatePermission = this.propertySetsHttpService.updatePropertySetPermission(payload, propertySetId);
    if (updatePermission) {
      updatePermission.subscribe({
        next: () => {
          this.permissions$ = this.loadPermissions(propertySetId);
        },
        error: err => {
          if (err.status === 400) {
            this.cbreAlertService.showErrorSnackBar(
              this.translationService.translate('propertySet.recordExists').replace('{{type}}', payload[0].type)
            );
          }
        },
      });
    }
  }
}
